import React from "react";

function Footer() {
  const footerSections = [
    {
      title: "Services",
      links: [
        { label: "Find Co-founder", url: "/search" },
        { label: "Community Feed", url: "/feed" },
        { label: "MVP Development", url: "/mvp-development" },
        { label: "Startup Jobs", url: "/startup-jobs" },
      ]
    },
    {
      title: "Company",
      links: [
        { label: "About Us", url: "/about" },
        { label: "Vision", url: "/vision" },
        { label: "Careers", url: "/careers" },
      ]
    },
    {
      title: "Resources",
      links: [
        { label: "Pricing", url: "/pricing" },
        { label: "Help Center", url: "/help" },
        { label: "Contact Us", url: "/contact" },
      ]
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Terms of Service", url: "/terms-of-service" },
        { label: "Cookie Policy", url: "/cookie-policy" },
      ]
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Logo Section */}
          <div className="footer-logo-section">
            <div className="footer-logo">
              <div className="footer-logo-icon">CH</div>
              <span className="footer-logo-text">CofounderHubs</span>
            </div>
            <h2 className="footer-tagline">United Co-founders.</h2>
            <p className="footer-description">
              CofounderHubs helps startups and entrepreneurs discover co-founders, candidates, investors, and business opportunities in one platform.
            </p>
            <div className="footer-contact-info">
              <a href="mailto:hr@cofounderhubs.com" className="contact-item" title="Email">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
                <span>hr@cofounderhubs.com</span>
              </a>
              <a href="tel:+17793363216" className="contact-item" title="Phone">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>+1 (779) 336-3216</span>
              </a>
            </div>
            <div className="footer-social-links">
              <a href="https://linkedin.com/company/cofounderhubs" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="Follow us on LinkedIn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
              {/* <a href="https://facebook.com/cofounderhubs" target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Follow us on Facebook">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a> */}
              <a href="https://instagram.com/cofounderhubs" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Follow us on Instagram">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
                </svg>
              </a>
              {/* <a href="https://dev.to/cofounderhubs" target="_blank" rel="noopener noreferrer" aria-label="Dev.to" title="Follow us on Dev.to">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 0h17C21.57 0 24 2.43 24 5.5v13c0 3.07-2.43 5.5-5.5 5.5h-17C2.43 24 0 21.57 0 18.5v-13C0 2.43 2.43 0 3.5 0zm6.31 6.77c-1.6 0-2.38 1.02-2.38 2.37v6.72c0 1.35.78 2.37 2.38 2.37 1.6 0 2.38-1.02 2.38-2.37V9.14c0-1.35-.78-2.37-2.38-2.37zm7.72 0c-1.6 0-2.38 1.02-2.38 2.37v6.72c0 1.35.78 2.37 2.38 2.37 1.6 0 2.38-1.02 2.38-2.37V9.14c0-1.35-.78-2.37-2.38-2.37z" />
                </svg>
              </a> */}
              {/* <a href="https://x.com/cofounderhubs" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" title="Follow us on X">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.207-6.807-5.974 6.807H2.882l7.432-8.491L1.227 2.25h6.836l4.713 6.231 5.486-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a> */}
            </div>
          </div>

          {/* Links Grid */}
          <div className="footer-links-grid">
            {footerSections.map((section) => (
              <div key={section.title} className="footer-column">
                <h4 className="footer-column-title">{section.title}</h4>
                <ul className="footer-links-list">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.url}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-divider"></div>
        <div className="footer-bottom">
          {/* <div className="footer-contact-info">
            <a href="mailto:hello@cofounderhubs.com" className="contact-item" title="Email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
              <span>hr@cofounderhubs.com</span>
            </a>
            <a href="tel:+17793363216" className="contact-item" title="Phone">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>+1 (779) 336-3216</span>
            </a>
            <div className="contact-item" title="Location">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>Washington St, Boston, MA</span>
            </div>
          </div> */}
          <p className="footer-copyright">© 2026 CofounderHubs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
